import { Grid, Card, Skeleton } from "@mui/material";

const BundleSkeletonLoading = ({ count = 3, mobile = false }) => {
  return (
    <Grid container spacing={1.5} sx={{ mt: 1 }}>
      {[...Array(count)].map((_, index) => (
        <Grid key={index} item xs={6} sm={6} md={4}>
          <Card
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: 1,
            }}
          >
            <Skeleton
              variant="rectangular"
              width={mobile ? 150 : 350}
              height={mobile ? 150 : 300}
            />
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default BundleSkeletonLoading;
